import { defineComponent as t, openBlock as r, createBlock as a, normalizeProps as n, guardReactiveProps as p, withCtx as l, renderSlot as s, createElementVNode as c } from "vue";
import m from "../CdrIcon.vue.mjs";
const d = /* @__PURE__ */ c("path", {
  role: "presentation",
  d: "M19.998 3a1 1 0 011 1l-.011 7.587a1 1 0 01-.293.705l-8.404 8.414a1 1 0 01-1.411.004l-7.582-7.506a1 1 0 01-.007-1.415l8.402-8.492A1 1 0 0112.403 3h7.595zm-1.002 2h-6.175l-7.408 7.485 6.165 6.103 7.41-7.417L18.995 5zM16.75 6a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5z"
}, null, -1), f = /* @__PURE__ */ t({
  name: "CouponStroke",
  __name: "coupon-stroke",
  props: {
    props: {
      type: Object
    }
  },
  setup(e) {
    return (o, u) => (r(), a(m, n(p(e.props)), {
      default: l(() => [s(o.$slots, "default"), d]),
      _: 3
    }, 16));
  }
});
export {
  f as default
};
